import { LinearScale } from '@mui/icons-material';
import { Tooltip, Stack, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeColorDarker } from '../../utils/colors'

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: 'white',
    color: "black",
    maxWidth: 400,
    border: '2px solid grey',
    fontSize: "12pt",
    padding: "16px",
    fontWeight: "400",
  },
}));

export const ChartLegend = ({ 
  payload,
  components,
  toggleBarVisibility,
  handleLegendMouseEnter,
  handleLegendMouseLeave,
  hover,
  fields,
}) => {
  return (
    <Box mt={2} mb={1}>
      <Stack
        direction="row"
        justifyContent="center"
        flexWrap="wrap"
        // spacing={8}
      >
        {
          payload.map((entry, index) => {
            if (entry.value === "total") {
              return (
                <Box
                  key={`item-${index}`}
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    '&:hover': {
                      cursor: 'pointer'
                    }
                  }}
                  onClick={() => toggleBarVisibility(entry.value)}
                  onMouseEnter={() => handleLegendMouseEnter(entry.value)}
                  onMouseLeave={() => handleLegendMouseLeave()}
                >
                  <LinearScale
                    fontSize='small'
                    style={{color:fields[entry.value]?'black':'gray'}}
                  />
                  <Box
                    sx={{
                      color: fields[entry.value] ? 'black' : 'gray',
                      fontWeight: 500,
                      textTransform: 'capitalize',
                    }}
                  >
                    {entry.value}
                  </Box>
                </Box>
              )
            }

            return (
              <CustomTooltip
                key={`item-${index}`}
                placement="top"
                title={components[entry.value]?.address}
                onClick={() => toggleBarVisibility(entry.value)}
              >
                <Box
                  sx={{
                    alignItems: 'center',
                    borderColor:hover==entry.value?fields[entry.value]?makeColorDarker(entry.color, 80):'gray':'transparent',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderRadius: 1,
                    display: 'flex',
                    gap: "4px",
                    padding: "4px",
                    '&:hover': {
                      cursor: 'pointer'
                    }
                  }}
                  onMouseEnter={() => {
                    handleLegendMouseEnter(entry.value);
                  }}
                  onMouseLeave={() => {
                    handleLegendMouseLeave();
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: fields[entry.value]?entry.color:'gray',
                      borderRadius: '4px',
                      height: '15px',
                      width: '15px',
                    }}
                  />
                  <Box
                    sx={{
                      color: fields[entry.value] ? 'black' : 'gray',
                      fontWeight: 500,
                    }}
                  >
                    {entry.value}
                  </Box>
                </Box>
              </CustomTooltip>
            )
          })
        }
      </Stack>
    </Box>
  );
}

